module.exports = __webpack_public_path__ + "svg/adult.svg?037438feef35fd8907e65c02ce09bdab";